import React from 'react';
import { useIntl } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import messages from '../messages';
import style from './velocity-chart.module.less';

/**
 * NoHistoricalData component that displays a message when there is no historical data for a product
 * @returns {React.ReactElement} The rendered NoHistoricalData component
 */
export const NoHistoricalData = () => {
  const intl = useIntl();

  return (
    <div className={style['no-data']}>
      <Text className={style['no-data-title']} textType={TextType.Heading4} value={intl.formatMessage(messages.noHistoricalDataTitle)} />
      <Text
        className={style['no-data-description']}
        textType={TextType.Paragraph}
        value={intl.formatMessage(messages.noHistoricalDataDescription)}
      />
    </div>
  );
};

export default NoHistoricalData;
